import { useMediaQuery } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

import { LogoConstants } from '@/src/shared/constants/CommonConstants';
import { smallScreenTab } from '@/src/shared/constants/MediaQueryConstants';
import { useAppRoute } from '@/src/shared/hooks/useAppRoute';
import { getBlobUrl } from '@/src/utils/commonUtil';

export const Logo = () => {
    const isMobileScreen: boolean = useMediaQuery(smallScreenTab);
    const brandLogo = getBlobUrl(LogoConstants.logo);
    const { isHomePage } = useAppRoute();

    const logoImage = (
        <Image
            src={brandLogo}
            alt={LogoConstants.logo}
            className="ginger-logo"
            priority
            width={isMobileScreen ? 102 : 122}
            height={45}
        />
    );

    return (
        <>
            {isHomePage ? (
                logoImage
            ) : (
                <Link href={process.env.NEXT_PUBLIC_MSAL_REDIRECT_URL as string}>{logoImage}</Link>
            )}
        </>
    );
};
